"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.map_pin = void 0;

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var map_pin = function map_pin(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'map-pin-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    // eslint-disable-next-line max-len
    d: 'M10 2.75C7.08793 2.75 4.75 5.06584 4.75 7.89474C4.75 10.1552 6.11054 12.5103 7.58803 14.3766C8.3139 15.2935 9.04155 16.0596 9.58812 16.5966C9.74138 16.7472 9.88005 16.8794 10 16.9914C10.12 16.8794 10.2586 16.7472 10.4119 16.5966C10.9584 16.0596 11.6861 15.2935 12.412 14.3766C13.8895 12.5103 15.25 10.1552 15.25 7.89474C15.25 5.06584 12.9121 2.75 10 2.75ZM10 18C9.5169 18.5737 9.51674 18.5735 9.51655 18.5734L9.51032 18.5681L9.49517 18.5552C9.48228 18.5442 9.46387 18.5283 9.44029 18.5078C9.39313 18.4668 9.32531 18.4071 9.23977 18.3299C9.06875 18.1756 8.82655 17.9512 8.53688 17.6666C7.95845 17.0983 7.1861 16.2855 6.41197 15.3076C4.88946 13.3845 3.25 10.6869 3.25 7.89474C3.25 4.21249 6.28465 1.25 10 1.25C13.7154 1.25 16.75 4.21249 16.75 7.89474C16.75 10.6869 15.1105 13.3845 13.588 15.3076C12.8139 16.2855 12.0416 17.0983 11.4631 17.6666C11.1734 17.9512 10.9313 18.1756 10.7602 18.3299C10.6747 18.4071 10.6069 18.4668 10.5597 18.5078C10.5361 18.5283 10.5177 18.5442 10.5048 18.5552L10.4897 18.5681L10.4839 18.573C10.4837 18.5731 10.4831 18.5737 10 18ZM10 18L10.4831 18.5737C10.2039 18.8088 9.79572 18.8085 9.51655 18.5734L10 18ZM10 6.75C9.30964 6.75 8.75 7.30964 8.75 8C8.75 8.69036 9.30964 9.25 10 9.25C10.6904 9.25 11.25 8.69036 11.25 8C11.25 7.30964 10.6904 6.75 10 6.75ZM7.25 8C7.25 6.48122 8.48122 5.25 10 5.25C11.5188 5.25 12.75 6.48122 12.75 8C12.75 9.51878 11.5188 10.75 10 10.75C8.48122 10.75 7.25 9.51878 7.25 8Z',
    fill: '#4B5563'
  }));
};

exports.map_pin = map_pin;